const DOMAIN_QUESTION_TYPE = {
  grammaire: 'grammar',
  orthographe: 'spelling',
  vocabulaire: 'vocabulary',
  comprehension: 'comprehension',
};

const DOMAIN_DEFAULT_GAME_TYPE = {
  grammaire: 'speed_game',
  orthographe: 'speed_game',
  vocabulaire: 'speed_game',
  comprehension: 'text_holes',
};

export function schoolLevelToCycle(schoolLevel) {
  const level = String(schoolLevel || '').trim();
  if (['CP', 'CE1', 'CE2'].includes(level)) return 2;
  if (['CM1', 'CM2', '6ème', '6eme'].includes(level)) return 3;
  if (['5ème', '5eme', '4ème', '4eme', '3ème', '3eme'].includes(level)) return 4;
  return 3;
}

export function domainToQuestionType(domain) {
  return DOMAIN_QUESTION_TYPE[domain] || 'spelling';
}

export function getDefaultGameTypeForDomain(domain) {
  return DOMAIN_DEFAULT_GAME_TYPE[domain] || 'speed_game';
}

/**
 * Enrichit les paramètres envoyés à POST /admin/exercises/generate.
 * Le backend ré-applique la même logique côté serveur.
 */
export function resolveParametersCycle(parameters = {}) {
  if (parameters.cycle != null && parameters.cycle !== '') {
    return Number(parameters.cycle);
  }
  const level = parameters.schoolLevel ?? parameters.level;
  if (level) return schoolLevelToCycle(level);
  return '';
}

export function enrichGenerationParameters(parameters = {}, gameType) {
  const params = { ...parameters };
  const domain = params.competence?.domain;
  const notion = params.competence?.notion;

  if (params.schoolLevel && params.cycle == null) {
    params.cycle = schoolLevelToCycle(params.schoolLevel);
  }
  if (!params.level && params.schoolLevel) {
    params.level = params.schoolLevel;
  }

  if (gameType === 'speed_game' && domain && !params.questionType) {
    params.questionType = domainToQuestionType(domain);
  }

  if (notion) {
    params.lesson = notion;
  }

  return params;
}
